import { FilterSchema } from '../../../../../core/base/interfaces/filter-schema.interface';
import { EstablishmentService } from '../../establishment/establishment.service';
import { UserProfileService } from '../../user-profile/user-profile.service';
import { GenericEquipmentService } from '../../../settings/generic-equipment/generic-equipment.service';
import { GenericMetrikStatusService } from '../../../settings/generic-metrik-status/generic-metrik-status.service';
import { GenericMetrikStatusModel } from '../../../../../core/models/generic-metrik-status.model';

/** Libellé d'un statut de fonctionnement dans le filtre : « Type - Motif » quand le motif existe. */
export const toMetrikStatusOption = (metrik: GenericMetrikStatusModel): GenericMetrikStatusModel => ({
  ...metrik,
  displayLabel: metrik.reason ? `${metrik.type} - ${metrik.reason}` : metrik.type,
});

export const EQUIPMENT_FILTER_SCHEMA: FilterSchema = {
  technicalIdentifier: { type: 'text' },
  reference: { type: 'text' },
  metrikStatus: {
    type: 'entity[]',
    resolve: { service: GenericMetrikStatusService, displayProperty: 'displayLabel', map: toMetrikStatusOption },
  },
  // Valeurs distinctes projetées : la chip est la valeur elle-même, l'état autocomplete est fusionné sur ce champ
  markList: { type: 'value[]', control: 'mark', valueField: 'mark' },
  modelList: { type: 'value[]', control: 'model', valueField: 'model' },
  serialNumberList: { type: 'value[]', control: 'serialNumber', valueField: 'serialNumber' },
  // Supervision métier de l'équipement (`contactIntern`), liste restreinte aux contacts « Supervision métier »
  contactInternIds: {
    type: 'entity[]',
    control: 'contactIntern',
    resolve: { service: UserProfileService, key: 'users', displayProperty: 'fullName' },
  },
  genericEquipments: { type: 'entity[]', resolve: { service: GenericEquipmentService, displayProperty: 'label' } },
  establishments: { type: 'entity[]', resolve: { service: EstablishmentService, displayProperty: 'label' } },
  commissioningDate: { type: 'range', form: 'commissioningDate' },
};
